// 全局下拉加载指令
export default {
  bind(el, binding) {
    const SELECTWRAP_DOM = el.querySelector(
      ".el-select-dropdown .el-select-dropdown__wrap"
    );
    SELECTWRAP_DOM.addEventListener("scroll", function() {
      /**
       * scrollHeight 获取元素内容高度
       * scrollTop 获取或者设置元素的偏移值，常用于计算滚动条的位置，当一个元素的容器没有产生垂直方向的滚动条，那它的scrollTop值默认为0
       * clientHeight 获取元素的可见高度
       * 如果元素滚动到底，下面的等式返回true,没有则返回false
       *
       **/
      //  +10 提前触发滚动，防止浏览器放大缩小导致高度变化而无法触底滚动加载
      const condition =
        this.scrollHeight - this.scrollTop <= this.clientHeight + 10;
      if (condition) {
        binding.value[0](binding.value[1], binding.value[2]);
      }
    });
  }
};
